import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "parkingSideBar" }
const _hoisted_2 = { class: "flex inputFilter" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_filter" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "topBorder" }, [
  /*#__PURE__*/_createElementVNode("small")
], -1)
const _hoisted_6 = { class: "flex toggleBtn wrapper" }
const _hoisted_7 = {
  key: 0,
  class: "warpit_icon_parking-smart"
}
const _hoisted_8 = {
  key: 1,
  class: "warpit_icon_parking"
}
const _hoisted_9 = { class: "wrapper" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "numOfBar" }
const _hoisted_12 = { class: "flex dist" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "km" }, null, -1)
const _hoisted_14 = { class: "icons flex" }
const _hoisted_15 = {
  key: 0,
  class: "warpit_icon_car"
}
const _hoisted_16 = {
  key: 1,
  class: "warpit_icon_el-polnilnica"
}
const _hoisted_17 = {
  key: 2,
  class: "warpit_icon_invalid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InfinityScroll = _resolveComponent("InfinityScroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Search, {
        modelValue: _ctx.searchTerm,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadParkings()))
      }, null, 8, ["modelValue"]),
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilters = !_ctx.showFilters))
      }, _hoisted_4)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["filter", { active: _ctx.showFilters }])
    }, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_InputSwitch, {
          modelValue: _ctx.smartParking,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.smartParking) = $event)),
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadParkings()))
        }, null, 8, ["modelValue"]),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("sidebar_parking.only_smart")), 1)
      ])
    ], 2),
    _createVNode(_component_InfinityScroll, {
      onLoadNextPage: _ctx.loadParkings,
      data: _ctx.parkings,
      class: "parkingsAvailable"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parkings.data, (parking) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: parking.id,
            to: { name: 'ParkingById', params: { id: parking.id } },
            class: "flex customTabLink",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('sidebar-toggled')))
          }, {
            default: _withCtx(() => [
              (parking.smart)
                ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                : (_openBlock(), _createElementBlock("i", _hoisted_8)),
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(parking.name) + ", " + _toDisplayString(parking.address), 1),
                (parking.smart)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["progressBar", _ctx.getValueColorClass(parking)])
                    }, [
                      _createVNode(_component_ProgressBar, {
                        value: _ctx.getOccupancy(parking)
                      }, null, 8, ["value"]),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(parking.spaces_accessible +
              parking.spaces_ev +
              parking.spaces_parent +
              parking.spaces_regular), 1)
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    (parking.spaces_regular)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                      : _createCommentVNode("", true),
                    (parking.spaces_ev)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                      : _createCommentVNode("", true),
                    (parking.spaces_accessible)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onLoadNextPage", "data"])
  ]))
}